<template>
    <div class="auto-list form-control">
        <!-- optional indicators -->
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <template v-else>
            <i class="fa fa-search" v-show="isEmpty"></i>
            <i class="fa fa-times" v-show="isDirty" @click="blur"></i>
        </template>

        <!-- the input field -->
        <input type="text" class="form-control popup-input" autocomplete="off" v-model="query" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter.prevent="hit" @keydown.right="hit" @keydown.esc="blur" @blur="blur" @input="keydown" @click="keydown" /> <br />

        <!-- the list -->
        <ul v-show="hasItems">
            <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
                <span v-text="item.name"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    import VueTypeahead from '../methods/vue-typeahead.js';
    export default {
        mixins: [VueTypeahead], // vue@1.0.21-
        props: {
            name: { default: ' '}
        },
        data () {
            return {
                timeout: false,
                src: '/api/asana/find',
                result: false,
                limit: 20,
                minChars: 1,
                selectFirst: false, // Highlight the first item in the list (optional)
                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'search'
            }
        },
        created () {
        },
        methods: {
            keydown: function () {
                if (this.query === '') return;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    this.update();
                }.bind(this), 200);
            },
            blur () {
                this.items = [];
                this.loading = false;
                this.$emit('input', this.result);
            },
            update: function update() {
                var _this = this;
                this.loading = true;

                this.fetch().then(function (response) {
                    var data = response.data;
                    data = _this.prepareResponseData ? _this.prepareResponseData(data) : data;
                    _this.items = _this.limit ? data.slice(0, _this.limit) : data;
                    _this.current = -1;
                    _this.loading = false;

                    if (_this.selectFirst) {
                        _this.down();
                    }
                });
            },
            onHit (item) {
                this.result = item;
                this.query = this.result.name;
                this.blur();
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>